import { AbsoluteFill } from "remotion";
import { Img } from "remotion";
import { staticFile } from "remotion";

export const MediaTest = () => {
  return (
    <AbsoluteFill style={{ backgroundColor: "red" }}>
      <Img 
        src={staticFile("media/final-gold-mirror.jpg")}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          opacity: 1,
        }}
      />
    </AbsoluteFill>
  );
};